import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
export class FirebaseUsernameGenerator {
    db = getFirestore();
    coll = collection(this.db, "users");
    async generateUniqueId() {
        for (let attempt = 0; attempt < 10; attempt++) {
            const digits = Math.floor(100000 + Math.random() * 900000).toString();
            const username = `u${digits}`;
            const q = query(this.coll, where("username", "==", username));
            const snap = await getDocs(q);
            if (snap.empty)
                return username;
        }
        throw new Error("Failed to generate unique username after 10 attempts");
    }
}
//# sourceMappingURL=FirebaseUsernameGenerator.js.map